import { createStaticReducer } from '../utils/redux/createStaticReducer';

export const geoSubdomainsReducer = createStaticReducer<string[]>([]);
